import {ValueObject} from '@s-ui/domain'

export default class AmountValueObject extends ValueObject {
  /**
   * @param {Object} amount
   * @param {Number} amount.amountLabelValue
   * @param {Number} amount.value
   * @param {String} amount.currency
   * */

  getAmount = () => {
    return {
      amountLabelValue: this._amountLabelValue,
      value: this._value,
      currency: this._currency
    }
  }
}
